export default "__VITE_ASSET__815b9548__"